
import { faLoader } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

type LoaderProps = {
    text?: string
}

const Loader = (props: LoaderProps) => {
    return (
        <Box sx={props?.text ? {
            width: "100%",
            height: "calc(100% - 104px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        } : {
            width: "100%",
            height: "calc(100% - 104px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}
        >
            <FontAwesomeIcon icon={faLoader} spinPulse style={{ "--fa-primary-color": "#000000", "--fa-secondary-color": "#000000", height: "24px", width: "24px" }} />
            {props?.text && <Typography fontSize={"18px"}>
                {props?.text}
            </Typography>}
        </Box>
    )
}

export default Loader
